module.exports = __webpack_public_path__ + "static/media/Producto-Solmáforo.a6fb12a3.jpg";